// import {
//   Box,
//   Grid,
//   Paper,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   Button,
//   Typography,
//   useTheme,
//   useMediaQuery,
// } from '@mui/material';
// import { find } from 'lodash';
// import eventService from '../../services/eventService';
// import pro360Logo from '../../assets/images/pro360-logo.png';

// import React, { useEffect, useRef, useState } from 'react';
// import {
//   Data,
//   GoogleMap,
//   InfoWindow,
//   LoadScript,
//   Marker,
//   Polyline,
// } from '@react-google-maps/api';
// import { parseISO } from 'date-fns';
// import axios from 'axios';
// import Cookies from 'js-cookie';

// const containerStyle = {
//   width: '100%',
//   height: '600px',
// };

// const center = {
//   lat: 28.6139,
//   lng: 77.209,
// };

// const EMAIL = '9512292402';
// const PASSWORD = 'Iks@5456';

// const LOGIN_URL = 'https://web.onelap.in/api/session';
// const WS_URL = 'wss://web.onelap.in/api/socket';

// // export default function MapHistory() {
// //   const [from, setFrom] = useState("");
// //   const [to, setTo] = useState("");
// //   const [vehicles, setVehicles] = useState([]);
// //   const [selectedVehicles, setSelectedVehicles] = useState([]);
// //   const [vehicleTracks, setVehicleTracks] = useState({});
// //   const [timeline, setTimeline] = useState(null);
// //   const [geoJsonUrl, setGeoJsonUrl] = useState(null);
// //   const [deviceLocations, setDeviceLocations] = useState({});
// //   const [connectionStatus, setConnectionStatus] = useState('Disconnected');
// //   const [debugLogs, setDebugLogs] = useState([]);
// //   const authToken = useRef(null);
// //   const ws = useRef(null);
// //   const reconnectTimeoutRef = useRef(null);
// //   const keepAliveIntervalRef = useRef(null);

// //   const addLog = (message) => {
// //     console.log(message);
// //     setDebugLogs((prev) =>
// //       [...prev, `${new Date().toLocaleTimeString()}: ${message}`].slice(-10)
// //     );
// //   };

// //   const fetchSession = async () => {
// //     try {
// //       addLog('Attempting to login with provided credentials...');

// //       const res = await axios.post(
// //         LOGIN_URL,
// //         new URLSearchParams({ email: EMAIL, password: PASSWORD }),
// //         {
// //           headers: {
// //             'Content-Type': 'application/x-www-form-urlencoded',
// //           },
// //           withCredentials: true,
// //         }
// //       );

// //       addLog(`Login response received: ${res.status}`);

// //       if (res.data) {
// //         // Based on the logs, it seems the API returns a user ID that can be used as a token
// //         if (
// //           typeof res.data === 'number' ||
// //           (typeof res.data === 'string' && !isNaN(res.data))
// //         ) {
// //           authToken.current = res.data.toString();
// //           addLog(`Auth token extracted: ${authToken.current}`);
// //           return true;
// //         }

// //         // If it's an object, look for common auth fields
// //         if (res.data.id || res.data.userId || res.data.sessionId) {
// //           authToken.current = (
// //             res.data.id ||
// //             res.data.userId ||
// //             res.data.sessionId
// //           ).toString();
// //           addLog(`User ID extracted as auth token: ${authToken.current}`);
// //           return true;
// //         }

// //         // Check for token field
// //         if (res.data.token) {
// //           authToken.current = res.data.token;
// //           addLog(`Token extracted: ${authToken.current}`);
// //           return true;
// //         }

// //         // If whole response is a string
// //         if (typeof res.data === 'string' && res.data.length > 0) {
// //           authToken.current = res.data;
// //           addLog(`Response data used as auth token: ${authToken.current}`);
// //           return true;
// //         }

// //         // Last resort: stringify response
// //         authToken.current = JSON.stringify(res.data);
// //         addLog('Full response stringified as auth token');
// //         return true;
// //       }

// //       addLog('No usable authentication data found in response');
// //       return false;
// //     } catch (err) {
// //       addLog(
// //         `Login failed: ${
// //           err.response ? JSON.stringify(err.response.data) : err.message
// //         }`
// //       );
// //       return false;
// //     }
// //   };

// //   const connectWebSocket = async () => {
// //     await fetchSession(); // ⬅ First fetch session with JSESSIONID stored automatically

// //     const wsUrl = `${WS_URL}`;
// //     addLog(`Connecting to WebSocket: ${wsUrl}`);

// //     ws.current = new WebSocket(wsUrl);

// //     ws.current.onopen = () => {
// //       addLog('✅ WebSocket connected');
// //       setConnectionStatus('Connected');

// //       // No need to send token manually unless server expects it
// //       // JSESSIONID is already in the browser cookie

// //       //   setupKeepAlive();
// //     };

// //     ws.current.onmessage = (event) => {
// //       const data = JSON.parse(event.data);
// //       console.log("WS Message:", data);
// //       if (data.deviceId) { //  && data.lat && data.lon
// //         console.log(`Device ${data.deviceId} at (${data.lat}, ${data.lon})`);
// //         setDeviceLocations((prev) => ({
// //           ...prev,
// //           [data.deviceId]: { lat: data.lat, lng: data.lon },
// //         }));
// //       }
// //     };

// //     ws.current.onerror = (err) => {
// //       console.error('WebSocket error:', err);
// //     };

// //     ws.current.onclose = (event) => {
// //       console.warn('WebSocket closed:', event);
// //     };
// //   };

// //   useEffect(() => {
// //     connectWebSocket();

// //     // Cleanup function
// //     return () => {
// //       if (ws.current) {
// //         ws.current.close();
// //       }
// //       if (reconnectTimeoutRef.current) {
// //         clearTimeout(reconnectTimeoutRef.current);
// //       }
// //       if (keepAliveIntervalRef.current) {
// //         clearInterval(keepAliveIntervalRef.current);
// //       }
// //     };
// //   }, []);

// //   const handleTimelineChange = (e) => {
// //     const selectedTime = new Date(parseInt(e.target.value));
// //     setTimeline(selectedTime);
// //   };

// //   const getMarkersAtTime = () => {
// //     if (!timeline) return [];
// //     let markers = [];
// //     for (const [vehicleId, points] of Object.entries(vehicleTracks)) {
// //       if (points.length === 0) continue;
// //       const closest = points.reduce((prev, curr) =>
// //         Math.abs(new Date(curr.timestamp) - timeline) <
// //         Math.abs(new Date(prev.timestamp) - timeline) ? curr : prev
// //       );
// //       markers.push({ vehicleId, ...closest });
// //     }
// //     return markers;
// //   };

// //   return (
// //     <div className="p-4">
// //       <h2 className="text-xl font-bold mb-4">OneLap Vehicle Tracker</h2>
// //       <form onSubmit={fetchPositions} className="space-y-2 mb-4">
// //         <div>
// //           <label className="mr-2">From:</label>
// //           <input type="datetime-local" value={from} onChange={(e) => setFrom(e.target.value)} />
// //         </div>
// //         <div>
// //           <label className="mr-2">To:</label>
// //           <input type="datetime-local" value={to} onChange={(e) => setTo(e.target.value)} />
// //         </div>
// //         <div>
// //           <label className="mr-2">Vehicles:</label>
// //           <select multiple value={selectedVehicles} onChange={(e) =>
// //             setSelectedVehicles(Array.from(e.target.selectedOptions, opt => opt.value))}>
// //             {vehicles.map((v) => (
// //               <option key={v.id} value={v.id}>{v.name}</option>
// //             ))}
// //           </select>
// //         </div>
// //         <div>
// //           <label className="mr-2">Upload GeoJSON:</label>
// //           <input type="file" accept=".geojson,application/geo+json" onChange={(e) => {
// //             const file = e.target.files[0];
// //             if (file) {
// //               setGeoJsonUrl(URL.createObjectURL(file));
// //             }
// //           }} />
// //         </div>
// //         <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded">Load Data</button>
// //       </form>

// //       {/* Timeline Slider */}
// //       {Object.keys(vehicleTracks).length > 0 && (
// //         <div className="mb-4">
// //           <input
// //             type="range"
// //             min={from ? parseISO(from).getTime() : 0}
// //             max={to ? parseISO(to).getTime() : 100}
// //             step={60 * 1000}
// //             onChange={handleTimelineChange}
// //           />
// //           <p>{timeline ? timeline.toLocaleString() : "Move the slider to see positions"}</p>
// //         </div>
// //       )}

// //       <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
// //         <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}>
// //           {/* Vehicle Routes */}
// //           {Object.entries(vehicleTracks).map(([vid, points]) => (
// //             <Polyline
// //               key={vid}
// //               path={points.map(p => ({ lat: p.lat, lng: p.lng }))}
// //               options={{ strokeColor: "#FF0000", strokeOpacity: 0.8, strokeWeight: 2 }}
// //             />
// //           ))}

// //           {/* Vehicle Markers based on Timeline */}
// //           {getMarkersAtTime().map(m => (
// //             <Marker
// //               key={m.vehicleId}
// //               position={{ lat: m.lat, lng: m.lng }}
// //               icon={{ url: "/vehicle-icon.png", scaledSize: new window.google.maps.Size(40, 40) }}
// //             />
// //           ))}

// //           {/* GeoJSON Route */}
// //           {geoJsonUrl && (
// //             <Data
// //               onLoad={(dataLayer) => {
// //                 fetch(geoJsonUrl)
// //                   .then(res => res.json())
// //                   .then(geojson => dataLayer.addGeoJson(geojson));
// //               }}
// //               options={{ style: { strokeColor: "#0000FF", strokeWeight: 2 } }}
// //             />
// //           )}
// //         </GoogleMap>
// //       </LoadScript>
// //     </div>
// //   );
// // }

// const mapContainerStyle = {
//   height: '97vh',
//   flexGrow: '1',
// };

// const carIconSVG = encodeURIComponent(`
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
//       <path fill="#3399cc" d="M480 256c0-32-64-64-160-96s-160 0-192 32C64 192 0 224 0 256v32c0 35.3 28.7 64 64 64h16c0 17.7 14.3 32 32 32s32-14.3 32-32h224c0 17.7 14.3 32 32 32s32-14.3 32-32h16c35.3 0 64-28.7 64-64v-32z"/>
//       <circle cx="128" cy="320" r="32" fill="#e6f2f8"/>
//       <circle cx="128" cy="320" r="16" fill="#336699"/>
//       <circle cx="384" cy="320" r="32" fill="#e6f2f8"/>
//       <circle cx="384" cy="320" r="16" fill="#336699"/>
//       <rect x="160" y="176" width="192" height="48" rx="10" fill="#2a7aa8"/>
//     </svg>
//     `);

// export default function MapHistory() {
//   const theme = useTheme();
//   const [vehicle, setVehicle] = useState('A1');
//   const [startTime, setStartTime] = useState('');
//   const [endTime, setEndTime] = useState('');
//   const [markers, setMarkers] = useState([]);
//   const [map, setMap] = useState(null);
//   const medicalMarkersRef = useRef([]); // Ref for medical markers (static)
//   const ambulanceMarkersRef = useRef([]); // Ref for ambulance markers (dynamic)
//   const [selectedMarker, setSelectedMarker] = useState(null);
//   const [events, setEvents] = useState([]);
//   const [deviceLocations, setDeviceLocations] = useState({});
//   const [connectionStatus, setConnectionStatus] = useState('Disconnected');
//   const [debugLogs, setDebugLogs] = useState([]);
//   const authToken = useRef(null);
//   const ws = useRef(null);
//   const reconnectTimeoutRef = useRef(null);
//   const keepAliveIntervalRef = useRef(null);
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
//   const geojsonFileUrl = `${process.env.REACT_APP_IMAGE_URL}/mapfiles/${events?.kml}`;
//   const iconUrls = {
//     161339: 'https://cdn-icons-png.flaticon.com/512/744/744465.png', // red car
//     161340: `data:image/svg+xml,${carIconSVG}`, // blue car
//     default: 'https://cdn-icons-png.flaticon.com/512/744/744480.png', // default car
//   };

//   useEffect(() => {
//     if (map && events?.kml) {
//       fetch(geojsonFileUrl)
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error('Network response was not ok');
//           }
//           return response.json();
//         })
//         .then((geojsonData) => {
//           // Add GeoJSON data to the map's data layer
//           map.data.addGeoJson(geojsonData);

//           const bounds = new window.google.maps.LatLngBounds();

//           // Iterate through the GeoJSON features to extend the bounds
//           map.data.forEach((feature) => {
//             const geometry = feature.getGeometry();
//             if (geometry.getType() === 'Point') {
//               bounds.extend(geometry.get());
//             } else if (geometry.getType() === 'LineString') {
//               geometry.getArray().forEach((latLng) => {
//                 bounds.extend(latLng);
//               });
//             }
//           });

//           // Set the map’s center based on the bounds center
//           map.setCenter(bounds.getCenter());

//           // Adjust zoom level to fit the bounds
//           map.fitBounds(bounds);

//           // Style the features
//           map.data.setStyle((feature) => ({
//             visible: feature.getGeometry().getType() !== 'Point',
//             fillColor: '#F38808',
//             strokeColor: '#F38808',
//             strokeWeight: 2,
//           }));
//         })
//         .catch((error) => {
//           console.error('Error loading GeoJSON file:', error);
//         });
//     }
//   }, [map, events]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // Call your API here with selected filters
//     try {
//       const response = await fetch(
//         `/api/your-endpoint?vehicle=${vehicle}&start=${startTime}&end=${endTime}`
//       );
//       const data = await response.json();
//       // Suppose API returns array of {lat, lng}
//       setMarkers(data);
//     } catch (error) {
//       console.error('API error', error);
//     }
//   };

//   const addLog = (message) => {
//     console.log(message);
//     setDebugLogs((prev) =>
//       [...prev, `${new Date().toLocaleTimeString()}: ${message}`].slice(-10)
//     );
//   };

//   const fetchSession = async () => {
//     try {
//       addLog('Attempting to login with provided credentials...');

//       const res = await axios.post(
//         LOGIN_URL,
//         new URLSearchParams({ email: EMAIL, password: PASSWORD }),
//         {
//           headers: {
//             'Content-Type': 'application/x-www-form-urlencoded',
//           },
//           withCredentials: true,
//         }
//       );

//       addLog(`Login response received: ${res.status}`);

//       if (res.data) {
//         // Based on the logs, it seems the API returns a user ID that can be used as a token
//         if (
//           typeof res.data === 'number' ||
//           (typeof res.data === 'string' && !isNaN(res.data))
//         ) {
//           authToken.current = res.data.toString();
//           addLog(`Auth token extracted: ${authToken.current}`);
//           return true;
//         }

//         // If it's an object, look for common auth fields
//         if (res.data.id || res.data.userId || res.data.sessionId) {
//           authToken.current = (
//             res.data.id ||
//             res.data.userId ||
//             res.data.sessionId
//           ).toString();
//           addLog(`User ID extracted as auth token: ${authToken.current}`);
//           return true;
//         }

//         // Check for token field
//         if (res.data.token) {
//           authToken.current = res.data.token;
//           addLog(`Token extracted: ${authToken.current}`);
//           return true;
//         }

//         // If whole response is a string
//         if (typeof res.data === 'string' && res.data.length > 0) {
//           authToken.current = res.data;
//           addLog(`Response data used as auth token: ${authToken.current}`);
//           return true;
//         }

//         // Last resort: stringify response
//         authToken.current = JSON.stringify(res.data);
//         addLog('Full response stringified as auth token');
//         return true;
//       }

//       addLog('No usable authentication data found in response');
//       return false;
//     } catch (err) {
//       addLog(
//         `Login failed: ${
//           err.response ? JSON.stringify(err.response.data) : err.message
//         }`
//       );
//       return false;
//     }
//   };

//   const connectWebSocket = async () => {
//     await fetchSession(); // ⬅ First fetch session with JSESSIONID stored automatically

//     const wsUrl = `${WS_URL}`;
//     addLog(`Connecting to WebSocket: ${wsUrl}`);

//     ws.current = new WebSocket(wsUrl);

//     ws.current.onopen = () => {
//       addLog('✅ WebSocket connected');
//       setConnectionStatus('Connected');

//       // No need to send token manually unless server expects it
//       // JSESSIONID is already in the browser cookie

//       //   setupKeepAlive();
//     };

//     ws.current.onmessage = (event) => {
//       const data = JSON.parse(event.data);
//       console.log('WS Message:', data);
//       if (data.deviceId) {
//         //  && data.lat && data.lon
//         console.log(`Device ${data.deviceId} at (${data.lat}, ${data.lon})`);
//         setDeviceLocations((prev) => ({
//           ...prev,
//           [data.deviceId]: { lat: data.lat, lng: data.lon },
//         }));
//       }
//     };

//     ws.current.onerror = (err) => {
//       console.error('WebSocket error:', err);
//     };

//     ws.current.onclose = (event) => {
//       console.warn('WebSocket closed:', event);
//     };
//   };

//   useEffect(() => {
//     const fetchEvents = async () => {
//       const response = await eventService.getEvents();
//       setEvents(find(response.data, { active: true }));
//     };
//     fetchEvents();

//     connectWebSocket();

//     // Cleanup function
//     return () => {
//       if (ws.current) {
//         ws.current.close();
//       }
//       if (reconnectTimeoutRef.current) {
//         clearTimeout(reconnectTimeoutRef.current);
//       }
//       if (keepAliveIntervalRef.current) {
//         clearInterval(keepAliveIntervalRef.current);
//       }
//     };

//   }, []);

//   const mapStyle = [
//     { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
//     { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
//     { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
//     {
//       featureType: 'administrative.locality',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'poi',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'poi.park',
//       elementType: 'geometry',
//       stylers: [{ color: '#263c3f' }],
//     },
//     {
//       featureType: 'poi.park',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#6b9a76' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'geometry',
//       stylers: [{ color: '#38414e' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'geometry.stroke',
//       stylers: [{ color: '#212a37' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#9ca5b3' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'geometry',
//       stylers: [{ color: '#746855' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'geometry.stroke',
//       stylers: [{ color: '#1f2835' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#f3d19c' }],
//     },
//     {
//       featureType: 'transit',
//       elementType: 'geometry',
//       stylers: [{ color: '#2f3948' }],
//     },
//     {
//       featureType: 'transit.station',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'geometry',
//       stylers: [{ color: '#17263c' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#515c6d' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'labels.text.stroke',
//       stylers: [{ color: '#17263c' }],
//     },
//   ];

//   return (
//     <Grid container spacing={1} sx={{ m: 0.2 }}>
//       {/* Left side: Form */}
//       <Grid item xs={12} md={2}>
//         <Paper elevation={3} sx={{ p: 3 }}>
//           <Typography variant='h6' gutterBottom>
//             Filter History
//           </Typography>
//           <Box
//             component='form'
//             onSubmit={handleSubmit}
//             sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
//           >
//             <FormControl fullWidth>
//               <InputLabel id='vehicle-label'>Vehicle</InputLabel>
//               <Select
//                 labelId='vehicle-label'
//                 value={vehicle}
//                 label='Vehicle'
//                 onChange={(e) => setVehicle(e.target.value)}
//               >
//                 <MenuItem value='A1'>A1</MenuItem>
//                 <MenuItem value='A2'>A2</MenuItem>
//                 <MenuItem value='A3'>A3</MenuItem>
//                 <MenuItem value='A4'>A4</MenuItem>
//                 <MenuItem value='A5'>A5</MenuItem>
//               </Select>
//             </FormControl>

//             <TextField
//               label='Start Time'
//               type='time'
//               InputLabelProps={{ shrink: true }}
//               inputProps={{ step: 300 }}
//               value={startTime}
//               onChange={(e) => setStartTime(e.target.value)}
//               fullWidth
//             />

//             <TextField
//               label='End Time'
//               type='time'
//               InputLabelProps={{ shrink: true }}
//               inputProps={{
//                 step: 300,
//               }}
//               value={endTime}
//               onChange={(e) => setEndTime(e.target.value)}
//               fullWidth
//             />

//             <Button type='submit' variant='contained' color='primary'>
//               Submit
//             </Button>
//           </Box>
//         </Paper>
//       </Grid>

//       {/* Right side: Map */}
//       <Grid item xs={12} md={9.9} sx={{ height: '100vh' }}>
//         <div
//           style={{
//             position: 'absolute',
//             top: '2rem',
//             right: isMobile ? '-2rem' : isTablet ? '-4rem' : '-5rem',
//             transform: 'translateX(-50%)',
//             zIndex: 999,
//           }}
//         >
//           <img
//             src={pro360Logo}
//             alt='Logo'
//             className='responsive-logo'
//             style={{
//               maxWidth: '20vw',
//               height: 'auto',
//               transition: 'max-width 0.3s ease',
//             }}
//           />
//         </div>

//         <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
//           <GoogleMap
//             mapContainerStyle={mapContainerStyle}
//             center={center}
//             options={{
//               styles: mapStyle,
//               mapTypeControl: false,
//               streetViewControl: false,
//               fullscreenControl: false,
//               scaleControl: false,
//               rotateControl: false,
//               zoomControl: true,
//             }}
//             onLoad={(mapInstance) => setMap(mapInstance)}
//             zoom={10}
//           >
//             <Data
//               onLoad={(data) => {
//                 data.setStyle((feature) => ({
//                   visible: feature.getGeometry().getType() !== 'Point',
//                   fillColor: '#FF0000',
//                   strokeColor: '#FF0000',
//                   strokeWeight: 2,
//                 }));
//               }}
//             />
//             {Object.entries(deviceLocations).map(([deviceId, info]) => (
//               <Marker
//                 key={deviceId}
//                 position={info}
//                 icon={{
//                   url: iconUrls[deviceId] || iconUrls['default'],
//                   scaledSize: new window.google.maps.Size(40, 40),
//                   ...(info.course !== undefined && {
//                     rotation: info.course,
//                   }),
//                 }}
//                 onClick={() => {
//                   setSelectedMarker({ ...info, deviceId });
//                 }}
//               />
//             ))}

//             {selectedMarker && (
//               <InfoWindow
//                 position={{
//                   lat: selectedMarker.lat,
//                   lng: selectedMarker.lng,
//                 }}
//                 onCloseClick={() => setSelectedMarker(null)}
//                 options={{
//                   pixelOffset: new window.google.maps.Size(0, -30), // Offset upward by 40 pixels
//                 }}
//               >
//                 <div>
//                   <h4>{selectedMarker.name || selectedMarker.deviceId}</h4>
//                   <p>Unit Type: GPS Device</p>
//                   <p>Latitude: {selectedMarker.lat}</p>
//                   <p>Longitude: {selectedMarker.lng}</p>
//                 </div>
//               </InfoWindow>
//             )}
//           </GoogleMap>
//         </LoadScript>
//       </Grid>
//     </Grid>
//   );
// }

// import React, { useEffect, useState, useRef, useCallback } from 'react';
// import {
//   GoogleMap,
//   LoadScript,
//   Marker,
//   Polyline,
//   useJsApiLoader,
// } from '@react-google-maps/api';

// import { Box, TextField, Button, Typography, IconButton } from '@mui/material';

// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import Autocomplete from '@mui/material/Autocomplete';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import PauseIcon from '@mui/icons-material/Pause';
// import dayjs from 'dayjs';
// import { DatePicker, TimePicker } from '@mui/x-date-pickers';
// import eventService from '../../services/eventService';
// import { find } from 'lodash';

// const EMAIL = '9512292402';
// const PASSWORD = 'Iks@5456';
// const BASE_URL = 'https://web.onelap.in';
// const LOGIN_URL = `${BASE_URL}/api/session`;
// const DEVICES_URL = `${BASE_URL}/api/devices`;
// const REPORTS_URL = `${BASE_URL}/api/reports/mini-route`;
// const WS_URL = `wss://web.onelap.in/api/socket`;

// const containerStyle = { width: '100vw', height: '100vh' };
// const center = { lat: 22.30905, lng: 73.18465 };

// export default function OneLapMap() {
//   const [devices, setDevices] = useState([]);
//   const [selectedDevices, setSelectedDevices] = useState([]);
//   const [positions, setPositions] = useState({}); // { deviceId: [points] }
//   const [timeline, setTimeline] = useState(null);
//   const [playing, setPlaying] = useState(false);
//   const [fromTime, setFromTime] = useState(dayjs().subtract(1, 'hour'));
//   const [toTime, setToTime] = useState(dayjs());
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [eventDetails, setEventDetails] = useState({});
//   const [map, setMap] = useState(null);
//   const [connectionStatus, setConnectionStatus] = useState('Disconnected');

//   const geojsonFileUrl = `${process.env.REACT_APP_IMAGE_URL}/mapfiles/${eventDetails?.kml}`;
//   const ws = useRef(null);
//   const playInterval = useRef(null);

//   // const { isLoaded } = useJsApiLoader({
//   //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
//   // });

//   // Stable fetchSession
//   const fetchSession = useCallback(async () => {
//     try {
//       const response = await fetch(LOGIN_URL, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//         credentials: 'include',
//         body: new URLSearchParams({ email: EMAIL, password: PASSWORD }),
//       });
//       return response.ok;
//     } catch (err) {
//       console.error('❌ Session error:', err);
//       return false;
//     }
//   }, []);

//   // Stable fetchDevices
//   const fetchDevices = useCallback(async () => {
//     try {
//       const res = await fetch(DEVICES_URL, { credentials: 'include' });
//       if (!res.ok) return [];
//       const data = await res.json();
//       console.log('data', data);

//       setDevices(data);
//       return data;
//     } catch (err) {
//       console.error('❌ Fetch devices error:', err);
//       return [];
//     }
//   }, []);

//   useEffect(() => {
//     if (map && eventDetails?.kml) {
//       fetch(geojsonFileUrl)
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error('Network response was not ok');
//           }
//           return response.json();
//         })
//         .then((geojsonData) => {
//           // Add GeoJSON data to the map's data layer
//           map.data.addGeoJson(geojsonData);

//           const bounds = new window.google.maps.LatLngBounds();

//           // Iterate through the GeoJSON features to extend the bounds
//           map.data.forEach((feature) => {
//             const geometry = feature.getGeometry();
//             if (geometry.getType() === 'Point') {
//               bounds.extend(geometry.get());
//             } else if (geometry.getType() === 'LineString') {
//               geometry.getArray().forEach((latLng) => {
//                 bounds.extend(latLng);
//               });
//             }
//           });

//           // Set the map’s center based on the bounds center
//           map.setCenter(bounds.getCenter());

//           // Adjust zoom level to fit the bounds
//           map.fitBounds(bounds);

//           // Style the features
//           map.data.setStyle((feature) => ({
//             visible: feature.getGeometry().getType() !== 'Point',
//             fillColor: '#F38808',
//             strokeColor: '#F38808',
//             strokeWeight: 2,
//           }));
//         })
//         .catch((error) => {
//           console.error('Error loading GeoJSON file:', error);
//         });
//     }
//   }, [map, eventDetails]);

//   useEffect(() => {
//     const fetchEvents = async () => {
//       const response = await eventService.getEvents();
//       setEventDetails(find(response.data, { active: true }));
//     };
//     fetchEvents();
//   }, []);

//   // Fetch route history for selected devices
//   const fetchRoute = useCallback(async () => {
//     const allPositions = {};
//     for (const dev of selectedDevices) {
//       const params = new URLSearchParams({
//         deviceId: dev.id,
//         from: fromTime.toISOString(),
//         to: toTime.toISOString(),
//         date: selectedDate,
//       });
//       const res = await fetch(`${REPORTS_URL}?${params}`, {
//         credentials: 'include',
//       });
//       if (res.ok) {
//         const data = await res.json();
//         allPositions[dev.id] = data.map((p) => ({
//           lat: p.latitude,
//           lng: p.longitude,
//           fixTime: new Date(p.fixedTime),
//         }));
//       }
//     }
//     setPositions(allPositions);
//     setTimeline(fromTime.toDate());

//     console.log("allPositions",allPositions);

//   }, [selectedDevices, fromTime, toTime]);

//   // Stable WebSocket connection
//   const connectWebSocket = useCallback(async () => {
//     await fetchSession();
//     await fetchDevices();

//     ws.current = new WebSocket(WS_URL);

//     ws.current.onopen = () => setConnectionStatus('Connected');

//     ws.current.onmessage = (event) => {
//       const data = JSON.parse(event.data);
//       if (data.positions) {
//         data.positions.forEach((pos) => {
//           setPositions((prev) => {
//             const arr = prev[pos.deviceId] || [];
//             return {
//               ...prev,
//               [pos.deviceId]: [
//                 ...arr,
//                 {
//                   lat: pos.latitude,
//                   lng: pos.longitude,
//                   fixTime: new Date(pos.fixTime),
//                 },
//               ],
//             };
//           });
//         });
//       }
//     };

//     ws.current.onclose = () => setConnectionStatus('Disconnected');
//   }, [fetchSession, fetchDevices]);

//   // Timeline play/pause
//   const togglePlay = () => {
//     if (playing) {
//       clearInterval(playInterval.current);
//       setPlaying(false);
//     } else {
//       playInterval.current = setInterval(() => {
//         setTimeline((t) => {
//           if (!t) return fromTime.toDate();
//           const next = new Date(t.getTime() + 60 * 1000); // step 1 min
//           if (next > toTime.toDate()) {
//             clearInterval(playInterval.current);
//             setPlaying(false);
//             return t;
//           }
//           return next;
//         });
//       }, 500);
//       setPlaying(true);
//     }
//   };

//   useEffect(() => {
//     connectWebSocket();
//     return () => {
//       if (ws.current) ws.current.close();
//       if (playInterval.current) clearInterval(playInterval.current);
//     };
//   }, [connectWebSocket]);

//   const mapStyle = [
//     { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
//     { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
//     { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
//     {
//       featureType: 'administrative.locality',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'poi',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'poi.park',
//       elementType: 'geometry',
//       stylers: [{ color: '#263c3f' }],
//     },
//     {
//       featureType: 'poi.park',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#6b9a76' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'geometry',
//       stylers: [{ color: '#38414e' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'geometry.stroke',
//       stylers: [{ color: '#212a37' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#9ca5b3' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'geometry',
//       stylers: [{ color: '#746855' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'geometry.stroke',
//       stylers: [{ color: '#1f2835' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#f3d19c' }],
//     },
//     {
//       featureType: 'transit',
//       elementType: 'geometry',
//       stylers: [{ color: '#2f3948' }],
//     },
//     {
//       featureType: 'transit.station',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'geometry',
//       stylers: [{ color: '#17263c' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#515c6d' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'labels.text.stroke',
//       stylers: [{ color: '#17263c' }],
//     },
//   ];

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 2 }}>
//         <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
//           <Autocomplete
//             multiple
//             options={devices}
//             disableCloseOnSelect
//             getOptionLabel={(d) => d.name || d.uniqueId || `Device ${d.id}`}
//             value={selectedDevices}
//             onChange={(e, v) => setSelectedDevices(v)}
//             renderInput={(params) => <TextField {...params} label='Devices' />}
//             sx={{
//               width: 300,
//               '& .MuiInputLabel-root': {
//                 top: -7,
//               },
//               '& .MuiOutlinedInput-root': {
//                 padding: 0,
//               },
//             }}
//           />

//           <DatePicker
//             label='Date'
//             value={selectedDate}
//             onChange={(newValue) => setSelectedDate(newValue)}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 sx={{
//                   '& .MuiInputLabel-root': {
//                     top: -7,
//                   },
//                   '& .MuiOutlinedInput-root': {
//                     padding: 0,
//                     paddingRight: 1.4,
//                   },
//                 }}
//               />
//             )}
//             sx={{
//               width: 300,
//               '& .MuiInputLabel-root': {
//                 top: -7,
//               },
//               '& .MuiOutlinedInput-root': {
//                 padding: 0,
//               },
//             }}
//           />

//           {/* From Time */}
//           <TimePicker
//             label='From'
//             value={fromTime}
//             onChange={(newValue) => setFromTime(newValue)}
//             renderInput={(params) => <TextField {...params} />}
//           />

//           {/* To Time */}
//           <TimePicker
//             label='To'
//             value={toTime}
//             onChange={(newValue) => setToTime(newValue)}
//             renderInput={(params) => <TextField {...params} />}
//           />
//           {/* <DateTimePicker
//             label='From'
//             value={fromTime}
//             onChange={(newValue) => setFromTime(newValue)}
//             renderInput={(params) => <TextField {...params} />}
//           />
//           <DateTimePicker
//             label='To'
//             value={toTime}
//             onChange={(newValue) => setToTime(newValue)}
//             renderInput={(params) => <TextField {...params} />}
//           /> */}

//           <Button
//             variant='contained'
//             onClick={fetchRoute}
//             sx={{ backgroundColor: '#BD210B' }}
//           >
//             Fetch Route
//           </Button>

//           {/* <IconButton color='primary' onClick={togglePlay}>
//             {playing ? <PauseIcon /> : <PlayArrowIcon />}
//           </IconButton> */}
//         </Box>

//         {/* <Typography sx={{ mt: 1 }}>Status: {connectionStatus}</Typography> */}
//       </Box>

//       <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
//       <GoogleMap
//            mapContainerStyle={containerStyle}
//            center={center}
//            options={{
//              styles: mapStyle,
//              mapTypeControl: false,
//              streetViewControl: false,
//              fullscreenControl: false,
//              scaleControl: false,
//              rotateControl: false,
//              zoomControl: true,
//            }}
//            onLoad={(mapInstance) => setMap(mapInstance)}
//            zoom={10}
//       >
//         {positions &&
//           Object.entries(positions).map(([deviceId, points]) => (
//             <React.Fragment key={deviceId}>
//               <Polyline
//                 path={points}
//                 options={{ strokeColor: '#1976d2', strokeWeight: 3 }}
//               />
//               {timeline && (
//                 <Marker
//                   position={
//                     points.find(
//                       (p) => p.fixTime.getTime() >= timeline.getTime()
//                     ) || points[0]
//                   }
//                   label={deviceId}
//                 />
//               )}
//             </React.Fragment>
//           ))}
//       </GoogleMap>
//       </LoadScript>

//       {timeline && (
//         <Box sx={{ p: 2 }}>
//           <input
//             type='range'
//             min={fromTime.toDate().getTime()}
//             max={toTime.toDate().getTime()}
//             step={60000}
//             value={timeline.getTime()}
//             onChange={(e) => setTimeline(new Date(parseInt(e.target.value)))}
//             style={{ width: '80%' }}
//           />
//           <Typography>{timeline.toLocaleString()}</Typography>
//         </Box>
//       )}
//     </LocalizationProvider>
//   );
// }

// Usage:
// 1. npm install @react-google-maps/api
// 2. <VehicleRouteMap apiKey={process.env.REACT_APP_GMAPS_KEY} data={routeData} />
// where `routeData` is the JSON array you pasted.

// import { useCallback, useEffect, useMemo, useState } from "react";
// import {
//   GoogleMap,
//   Marker,
//   Polyline,
//   InfoWindow,
//   useJsApiLoader,
// } from "@react-google-maps/api";

// const BASE_URL = 'https://web.onelap.in';
// const DEVICES_URL = `${BASE_URL}/api/devices`;

// export default function VehicleRouteMap({ apiKey, height = "600px" }) {
//   // data: array of points with { latitude, longitude, serverTime, speed, id }
//   const { isLoaded, loadError } = useJsApiLoader({
//     googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, // pass your API key via prop
//     libraries: ["places"],
//   });

//   const data = [
//     {
//       id: 161339,
//       attributes: {
//         hardwareCode: "ol_go",
//         markerPosition: 12,
//         vehicleNumber: "-",
//         deviceType: 105,
//         batteryLevel: "6",
//         activationDate: "2025-04-18 19:31:31",
//         ownerId: 195945,
//         modeOfPurchase: "ONELAP",
//         "eligble.factor.speed.runtime": 8,
//         simStatus: "SENT",
//         isTZFalse: true,
//         lastValidPosition: 0,
//       },
//       name: "A1",
//       uniqueId: "869689044531713",
//       status: "offline",
//       lastUpdate: "2025-04-27T03:39:29.549+0000",
//       positionId: 27984210635,
//     },
//     {
//       id: 161340,
//       attributes: {
//         hardwareCode: "ol_go",
//         markerPosition: 14,
//         deviceType: 105,
//         batteryLevel: 5,
//         activationDate: "2025-04-18 19:33:56",
//         ownerId: 195945,
//         modeOfPurchase: "ONELAP",
//         "eligble.factor.speed.runtime": 12,
//         simStatus: "SENT",
//         isTZFalse: true,
//         lastValidPosition: 0,
//         iccid: "8991102406385594914",
//         simChanged: true,
//       },
//       name: "A2",
//       uniqueId: "869689044533982",
//       status: "unknown",
//       lastUpdate: "2025-09-30T13:32:53.901+0000",
//       positionId: 34032049845,
//     },
//   ];

//   const [activeMarker, setActiveMarker] = useState(null);

//   // ✅ FIX: use dummy coords (replace with real lat/lng fields if your API has them)
//   const points = useMemo(() => {
//     if (!Array.isArray(data)) return [];
//     return data.map((p, idx) => ({
//       lat: 28.6139 + idx * 0.02, // dummy coords (New Delhi + offset)
//       lng: 77.209 + idx * 0.02,
//       time: p.lastUpdate,
//       speed: p.attributes?.["eligble.factor.speed.runtime"] ?? 0,
//       id: p.id,
//       name: p.name,
//       attrs: p.attributes || {},
//       index: idx + 1,
//     }));
//   }, [data]);

//   const center = useMemo(() => {
//     if (points.length) return { lat: points[0].lat, lng: points[0].lng };
//     return { lat: 0, lng: 0 };
//   }, [points]);

//   const onMarkerClick = useCallback((markerId) => {
//     setActiveMarker(markerId);
//   }, []);

//   const onMapClick = () => setActiveMarker(null);

//   const polylinePath = points.map((p) => ({ lat: p.lat, lng: p.lng }));

//   const mapContainerStyle = {
//     width: "100%",
//     height,
//   };

//   const options = {
//     clickableIcons: false,
//     fullscreenControl: false,
//     mapTypeControl: false,
//     streetViewControl: false,
//   };

//   const fetchDevices = useCallback(async () => {
//     try {
//       const res = await fetch("/api/devices", { credentials: "include" });
//       if (!res.ok) return [];
//       const data = await res.json();
//       console.log("data", data);

//       return data;
//     } catch (err) {
//       console.error("❌ Fetch devices error:", err);
//       return [];
//     }
//   }, []);

//   useEffect(() => {
//     fetchDevices();
//   }, [fetchDevices]);

//   const onMapLoad = useCallback(
//     (map) => {
//       if (!points.length) return;
//       const bounds = new window.google.maps.LatLngBounds();
//       points.forEach((p) => bounds.extend({ lat: p.lat, lng: p.lng }));
//       map.fitBounds(bounds);
//     },
//     [points]
//   );

//   if (loadError)
//     return <div className="p-4 text-red-600">Error loading Google Maps</div>;
//   if (!isLoaded) return <div className="p-4">Loading map...</div>;

//   return (
//     <div className="w-full rounded shadow-sm overflow-hidden">
//       <GoogleMap
//         mapContainerStyle={mapContainerStyle}
//         center={center}
//         zoom={15}
//         options={options}
//         onLoad={onMapLoad}
//         onClick={onMapClick}
//       >
//         {/* Polyline for the route */}
//         {polylinePath.length > 0 && (
//           <Polyline
//             path={polylinePath}
//             options={{
//               strokeColor: "#1976D2",
//               strokeOpacity: 0.9,
//               strokeWeight: 4,
//               clickable: false,
//               geodesic: true,
//             }}
//           />
//         )}

//         {/* Markers */}
//         {points.map((p) => (
//           <Marker
//             key={p.id}
//             position={{ lat: p.lat, lng: p.lng }}
//             label={{ text: String(p.index), color: "black", fontSize: "10px" }}
//             title={`${p.name} (#${p.index}) - ${p.time}`}
//             onClick={() => onMarkerClick(p.id)}
//           >
//             {activeMarker === p.id && (
//               <InfoWindow
//                 onCloseClick={() => setActiveMarker(null)}
//                 position={{ lat: p.lat, lng: p.lng }}
//               >
//                 <div className="text-sm">
//                   <div>
//                     <strong>Name:</strong> {p.name}
//                   </div>
//                   <div>
//                     <strong>Index:</strong> {p.index}
//                   </div>
//                   <div>
//                     <strong>Time:</strong> {p.time}
//                   </div>
//                   <div>
//                     <strong>Speed:</strong> {p.speed} km/h
//                   </div>
//                   <div>
//                     <strong>Lat:</strong> {p.lat.toFixed(6)}
//                   </div>
//                   <div>
//                     <strong>Lng:</strong> {p.lng.toFixed(6)}
//                   </div>
//                 </div>
//               </InfoWindow>
//             )}
//           </Marker>
//         ))}
//       </GoogleMap>

//       <div className="p-3 bg-white border-t">
//         <div className="text-sm text-gray-600">Points: {points.length}</div>
//         {points.length > 0 && (
//           <div className="text-sm text-gray-800 mt-1">
//             <strong>First:</strong> {points[0].time} &nbsp;{" "}
//             <strong>Last:</strong> {points[points.length - 1].time}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// import React, { useEffect, useState, useRef, useCallback } from 'react';
// import {
//   GoogleMap,
//   LoadScript,
//   Marker,
//   Polyline,
// } from '@react-google-maps/api';
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Autocomplete,
// } from '@mui/material';
// import { DatePicker, TimePicker } from '@mui/x-date-pickers';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';
// import eventService from '../../services/eventService';
// import { find } from 'lodash';

// const EMAIL = '9512292402';
// const PASSWORD = 'Iks@5456';
// const BASE_URL = 'https://web.onelap.in';
// const LOGIN_URL = `${BASE_URL}/api/session`;
// const DEVICES_URL = `${BASE_URL}/api/devices`;
// const REPORTS_URL = `${BASE_URL}/api/reports/mini-route`;
// const WS_URL = `wss://web.onelap.in/api/socket`;
// const containerStyle = { width: '100vw', height: '100vh' };
// const center = { lat: 22.30905, lng: 73.18465 };

// // 🚑 ambulance icon
// const ambulanceIcon = {
//   url: 'https://cdn-icons-png.flaticon.com/512/744/744465.png', // free ambulance png
//   scaledSize: { width: 40, height: 40 },
// };

// export default function OneLapMap() {
//   const [devices, setDevices] = useState([]);
//   const [selectedDevices, setSelectedDevices] = useState([]);
//   const [positions, setPositions] = useState({}); // { deviceId: [points] }
//   const [timeline, setTimeline] = useState(null);
//   const [fromTime, setFromTime] = useState(dayjs().subtract(1, 'hour'));
//   const [toTime, setToTime] = useState(dayjs());
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [eventDetails, setEventDetails] = useState({});
//   const [map, setMap] = useState(null);
//   const geojsonFileUrl = `${process.env.REACT_APP_IMAGE_URL}/mapfiles/${eventDetails?.kml}`;

//   const ws = useRef(null);
//   const playInterval = useRef(null);

//   useEffect(() => {
//     if (!map) return;

//     // 1️⃣ First, load GeoJSON if available
//     if (eventDetails?.kml) {
//       fetch(geojsonFileUrl)
//         .then((response) => {
//           if (!response.ok) throw new Error('Network response was not ok');
//           return response.json();
//         })
//         .then((geojsonData) => {
//           map.data.addGeoJson(geojsonData);

//           const bounds = new window.google.maps.LatLngBounds();

//           map.data.forEach((feature) => {
//             const geometry = feature.getGeometry();
//             if (geometry.getType() === 'Point') {
//               bounds.extend(geometry.get());
//             } else if (geometry.getType() === 'LineString') {
//               geometry.getArray().forEach((latLng) => bounds.extend(latLng));
//             }
//           });

//           map.data.setStyle((feature) => ({
//             visible: feature.getGeometry().getType() !== 'Point',
//             fillColor: '#F38808',
//             strokeColor: '#F38808',
//             strokeWeight: 2,
//           }));

//           // 2️⃣ Then, check if there are device positions
//           const allPoints = Object.values(positions).flat();
//           if (allPoints.length > 0) {
//             // Center on the **first point of the first device**
//             // map.setCenter({
//             //   lat: allPoints[0].lat,
//             //   lng: allPoints[0].lng,
//             // });
//           } else {
//             // Otherwise, use GeoJSON bounds center
//             // map.setCenter(bounds.getCenter());
//             map.fitBounds(bounds);
//           }
//         })
//         .catch((error) => console.error('Error loading GeoJSON file:', error));
//     }
//     //  else {
//     //   // If no GeoJSON, center on first device point if exists
//     //   const allPoints = Object.values(positions).flat();
//     //   if (allPoints.length > 0) {
//     //     map.setCenter({ lat: allPoints[0].lat, lng: allPoints[0].lng });
//     //   } else {
//     //     map.setCenter(center); // fallback
//     //   }
//     // }
//   }, [map, eventDetails, positions, geojsonFileUrl]);

//   //   useEffect(() => {
//   //   if (map && eventDetails?.kml) {
//   //     fetch(geojsonFileUrl)
//   //       .then((response) => {
//   //         if (!response.ok) {
//   //           throw new Error('Network response was not ok');
//   //         }
//   //         return response.json();
//   //       })
//   //       .then((geojsonData) => {
//   //         // Add GeoJSON data to the map's data layer
//   //         map.data.addGeoJson(geojsonData);

//   //         const bounds = new window.google.maps.LatLngBounds();

//   //         // Iterate through the GeoJSON features to extend the bounds
//   //         map.data.forEach((feature) => {
//   //           const geometry = feature.getGeometry();
//   //           if (geometry.getType() === 'Point') {
//   //             bounds.extend(geometry.get());
//   //           } else if (geometry.getType() === 'LineString') {
//   //             geometry.getArray().forEach((latLng) => {
//   //               bounds.extend(latLng);
//   //             });
//   //           }
//   //         });

//   //         // Set the map’s center based on the bounds center
//   //         map.setCenter(bounds.getCenter());

//   //         // Adjust zoom level to fit the bounds
//   //         map.fitBounds(bounds);

//   //         // Style the features
//   //         map.data.setStyle((feature) => ({
//   //           visible: feature.getGeometry().getType() !== 'Point',
//   //           fillColor: '#F38808',
//   //           strokeColor: '#F38808',
//   //           strokeWeight: 2,
//   //         }));
//   //       })
//   //       .catch((error) => {
//   //         console.error('Error loading GeoJSON file:', error);
//   //       });
//   //   }
//   // }, [map, eventDetails]);

//   useEffect(() => {
//     const fetchEvents = async () => {
//       const response = await eventService.getEvents();
//       setEventDetails(find(response.data, { active: true }));
//     };
//     fetchEvents();
//   }, []);

//   const mapStyle = [
//     { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
//     { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
//     { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
//     {
//       featureType: 'administrative.locality',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'poi',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'poi.park',
//       elementType: 'geometry',
//       stylers: [{ color: '#263c3f' }],
//     },
//     {
//       featureType: 'poi.park',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#6b9a76' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'geometry',
//       stylers: [{ color: '#38414e' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'geometry.stroke',
//       stylers: [{ color: '#212a37' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#9ca5b3' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'geometry',
//       stylers: [{ color: '#746855' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'geometry.stroke',
//       stylers: [{ color: '#1f2835' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#f3d19c' }],
//     },
//     {
//       featureType: 'transit',
//       elementType: 'geometry',
//       stylers: [{ color: '#2f3948' }],
//     },
//     {
//       featureType: 'transit.station',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'geometry',
//       stylers: [{ color: '#17263c' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#515c6d' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'labels.text.stroke',
//       stylers: [{ color: '#17263c' }],
//     },
//   ];

//   // Login session
//   const fetchSession = useCallback(async () => {
//     try {
//       const response = await fetch(LOGIN_URL, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//         credentials: 'include',
//         body: new URLSearchParams({ email: EMAIL, password: PASSWORD }),
//       });
//       return response.ok;
//     } catch (err) {
//       console.error('❌ Session error:', err);
//       return false;
//     }
//   }, []);

//   // Get devices
//   const fetchDevices = useCallback(async () => {
//     try {
//       const res = await fetch(DEVICES_URL, { credentials: 'include' });
//       if (!res.ok) return [];
//       const data = await res.json();
//       setDevices(data);
//       return data;
//     } catch (err) {
//       console.error('❌ Fetch devices error:', err);
//       return [];
//     }
//   }, []);

//   // Fetch route history
//   const fetchRoute = useCallback(async () => {
//     const allPositions = {};
//     for (const dev of selectedDevices) {
//       const params = new URLSearchParams({
//         deviceId: dev.id,
//         from: fromTime.toISOString(),
//         to: toTime.toISOString(),
//         date: selectedDate,
//       });
//       const res = await fetch(`${REPORTS_URL}?${params}`, {
//         credentials: 'include',
//       });
//       if (res.ok) {
//         const data = await res.json();
//         allPositions[dev.id] = data.map((p) => ({
//           lat: p.latitude,
//           lng: p.longitude,
//           fixTime: new Date(p.fixTime),
//         }));
//       }
//     }
//     setPositions(allPositions);
//     setTimeline(fromTime.toDate()); // start timeline
//     console.log('allPositions', allPositions);
//   }, [selectedDevices, fromTime, toTime, selectedDate]);

//   useEffect(() => {
//     const fetchEvents = async () => {
//       const response = await eventService.getEvents();
//       setEventDetails(find(response.data, { active: true }));
//     };
//     fetchEvents();
//     fetchDevices();
//   }, [fetchDevices]);

//   useEffect(() => {
//     if (!map) return;
//     if (selectedDevices.length === 0) return;

//     const firstDeviceId = selectedDevices[0].id;
//     const devicePoints = positions[firstDeviceId];
//     if (devicePoints && devicePoints.length > 0) {
//       map.setCenter(devicePoints[devicePoints.length - 1]);
//     }
//   }, [positions, selectedDevices, map]);

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 2 }}>
//         <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
//           <Autocomplete
//             multiple
//             options={devices}
//             disableCloseOnSelect
//             getOptionLabel={(d) => d.name || d.uniqueId || `Device ${d.id}`}
//             value={selectedDevices}
//             onChange={(e, v) => setSelectedDevices(v)}
//             isOptionEqualToValue={(option, value) => option.id === value.id} // ✅ FIX
//             renderInput={(params) => <TextField {...params} label='Devices' />}
//             sx={{
//               width: 300,
//               '& .MuiInputLabel-root': {
//                 top: -7,
//               },
//               '& .MuiOutlinedInput-root': {
//                 padding: 0,
//               },
//             }}
//           />

//           <DatePicker
//             label='Date'
//             value={selectedDate}
//             onChange={(newValue) => setSelectedDate(newValue)}
//             renderInput={(params) => <TextField {...params} />}
//           />

//           <TimePicker
//             label='From'
//             value={fromTime}
//             onChange={(newValue) => setFromTime(newValue)}
//             renderInput={(params) => <TextField {...params} />}
//           />

//           <TimePicker
//             label='to'
//             value={toTime}
//             onChange={(newValue) => setToTime(newValue)}
//             renderInput={(params) => <TextField {...params} />}
//           />

//           <Button
//             variant='contained'
//             onClick={fetchRoute}
//             sx={{ backgroundColor: '#BD210B' }}
//           >
//             Fetch Route
//           </Button>
//         </Box>
//       </Box>

//       <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
//         <GoogleMap
//           mapContainerStyle={containerStyle}
//           center={center}
//           zoom={20}
//           onLoad={(mapInstance) => setMap(mapInstance)}
//           options={{
//             styles: mapStyle,
//             mapTypeControl: false,
//             streetViewControl: false,
//             fullscreenControl: false,
//             scaleControl: false,
//             rotateControl: false,
//             zoomControl: true,
//           }}
//         >
//           {positions &&
//             Object.entries(positions).map(([deviceId, points]) =>
//               points.map((p, idx) => (
//                 <Marker
//                   key={`${deviceId}-${idx}`}
//                   position={{ lat: p.lat, lng: p.lng }}
//                   icon={ambulanceIcon}
//                   title={`Device ${deviceId} - ${p.fixTime}`}
//                 />
//               ))
//             )}
//         </GoogleMap>
//       </LoadScript>

//       {timeline && (
//         <Box sx={{ p: 2 }}>
//           <input
//             type='range'
//             min={fromTime.toDate().getTime()}
//             max={toTime.toDate().getTime()}
//             step={60000}
//             value={timeline.getTime()}
//             onChange={(e) => setTimeline(new Date(parseInt(e.target.value)))}
//             style={{ width: '80%' }}
//           />
//           <Typography>{timeline.toLocaleString()}</Typography>
//         </Box>
//       )}
//     </LocalizationProvider>
//   );
// }

import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import {
  GoogleMap,
  LoadScript,
  Marker,
  Polyline,
  useLoadScript,
} from '@react-google-maps/api';
import {
  Box,
  TextField,
  Button,
  Typography,
  Autocomplete,
} from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import eventService from '../../services/eventService';
import { find, isEmpty } from 'lodash';

const containerStyle = {
  width: '100%',
  height: 'calc(100vh - 80px)',
};
const EMAIL = '9512292402';
const PASSWORD = 'Iks@5456';
const BASE_URL = 'https://web.onelap.in';
const DEVICES_URL = `${BASE_URL}/api/devices`;
const REPORTS_URL = `${BASE_URL}/api/reports/mini-route`;
const WS_URL = `wss://web.onelap.in/api/socket`;

function VehicleRouteMap({ apiKey, data }) {
  const { isLoaded } = useLoadScript({ googleMapsApiKey: apiKey });
  const mapRef = useRef(null);
  const [icons, setIcons] = useState(null);

  // Initialize icons after Google Maps API is loaded
  useEffect(() => {
    if (isLoaded) {
      setIcons({
        startIcon: {
          //   url: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
          url: 'icons/start-line.svg',
          scaledSize: new window.google.maps.Size(40, 40),
        },
        endIcon: {
          //   url: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
          url: 'icons/finish-line.svg',
          scaledSize: new window.google.maps.Size(40, 40),
        },
        intermediateIcon: {
          //   url: "https://cdn-icons-png.flaticon.com/512/2967/2967350.png",
          url: 'icons/ambulance-location-icon.svg',
          scaledSize: new window.google.maps.Size(31, 31),
        },
      });
    }
  }, [isLoaded]);

  // Sort data by time
  const sortedData = useMemo(
    () =>
      [...data].sort((a, b) => new Date(a.fixedTime) - new Date(b.fixedTime)),
    [data]
  );

  // Get path for polyline
  const path = useMemo(
    () =>
      sortedData.map((point) => ({
        lat: point.latitude,
        lng: point.longitude,
      })),
    [sortedData]
  );

  // Compute center coordinates
  const center = useMemo(() => {
    if (path.length === 0) return { lat: 0, lng: 0 };
    const latSum = path.reduce((sum, p) => sum + p.lat, 0);
    const lngSum = path.reduce((sum, p) => sum + p.lng, 0);
    return { lat: latSum / path.length, lng: lngSum / path.length };
  }, [path]);

  const mapStyle = [
    { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#263c3f' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#6b9a76' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#38414e' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#212a37' }],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9ca5b3' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#746855' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#1f2835' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#f3d19c' }],
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ color: '#2f3948' }],
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#17263c' }],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#515c6d' }],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#17263c' }],
    },
  ];

  if (!isLoaded || !icons) return <div>Loading map...</div>;

  const lineSymbol = window.google?.maps?.SymbolPath
    ? {
        path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        scale: 3,
        strokeColor: '#ffffff',
      }
    : {
        path: 'M 0,0 0,5 2,5 0,3 5,3 3,5 5,5 z',
        scale: 3,
        strokeColor: '#ffffff',
        fillColor: '#ffffff',
        fillOpacity: 1,
      };

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={14} // adjust zoom as needed
      onLoad={(map) => (mapRef.current = map)}
      options={{
        styles: mapStyle,
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
      }}
    >
      {path.length > 0 && (
        <>
          <Polyline
            path={path}
            options={{
              strokeColor: '#007bff',
              strokeWeight: 4,
              icons: [
                {
                  icon: lineSymbol,
                  offset: '20%', // 👈 start after beginning
                  repeat: '100px', // 👈 spacing between arrows
                },
              ],
            }}
          />

          {/* Start marker */}
          <Marker position={path[0]} icon={icons.startIcon} />

          {/* End marker */}
          <Marker position={path[path.length - 1]} icon={icons.endIcon} />

          {/* Intermediate markers */}
          {path.slice(1, -1).map((pos, i) => (
            <Marker key={i} position={pos} icon={icons.intermediateIcon} />
          ))}
        </>
      )}
    </GoogleMap>
  );
}

export default function MapApp() {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const [devices, setDevices] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [positions, setPositions] = useState({}); // { deviceId: [points] }
  const [timeline, setTimeline] = useState(null);
  const [fromTime, setFromTime] = useState(dayjs().subtract(1, 'hour'));
  const [toTime, setToTime] = useState(dayjs());
  const [selectedDate, setSelectedDate] = useState(null);
  const [jsonData, setJsonData] = useState([]);

  const fetchRoute = useCallback(async () => {
    if (!selectedDate) return;

    // Merge selectedDate with fromTime/toTime hours/minutes
    const fromDateTime = selectedDate
      .hour(fromTime.hour())
      .minute(fromTime.minute())
      .second(0);

    const toDateTime = selectedDate
      .hour(toTime.hour())
      .minute(toTime.minute())
      .second(0);

    console.log(
      'Fetching route from:',
      fromDateTime.toISOString(),
      'to:',
      toDateTime.toISOString()
    );

    const allPositions = {};

    for (const dev of selectedDevices) {
      const params = new URLSearchParams({
        deviceId: dev.id,
        from: fromDateTime.toISOString(),
        to: toDateTime.toISOString(),
        date: selectedDate.format('YYYY-MM-DD'),
      });

      const res = await fetch(`${REPORTS_URL}?${params}`, {
        credentials: 'include',
      });
      if (res.ok) {
        const data = await res.json();
        allPositions[dev.id] = data.map((p) => ({
          lat: p.latitude,
          lng: p.longitude,
          fixTime: new Date(p.fixTime),
        }));
        console.log('datadatadata', data);
        setJsonData(data);
      }
    }

    setPositions(allPositions);
    setTimeline(fromDateTime.toDate()); // start timeline
    console.log('allPositions', allPositions);
  }, [selectedDevices, fromTime, toTime, selectedDate]);

  const fetchDevices = useCallback(async () => {
    try {
      const res = await fetch(DEVICES_URL, { credentials: 'include' });
      if (!res.ok) return [];
      const data = await res.json();
      if (!isEmpty(data)) {
        setDevices(
          [...data].sort((a, b) =>
            a?.name?.localeCompare(b?.name, undefined, { numeric: true })
          )
        );
      }
      return data;
    } catch (err) {
      console.error('❌ Fetch devices error:', err);
      return [];
    }
  }, []);

  console.log('devices', devices);

  useEffect(() => {
    fetchDevices();
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Autocomplete
            multiple
            options={devices}
            disableCloseOnSelect
            getOptionLabel={(d) => d.name || d.uniqueId || `Device ${d.id}`}
            value={selectedDevices}
            onChange={(e, v) => setSelectedDevices(v)}
            isOptionEqualToValue={(option, value) => option.id === value.id} // ✅ FIX
            renderInput={(params) => <TextField {...params} label='Devices' />}
            sx={{
              width: 300,
              '& .MuiInputLabel-root': {
                top: -7,
              },
              '& .MuiOutlinedInput-root': {
                padding: 0,
              },
            }}
          />

          <DatePicker
            label='Date'
            value={selectedDate}
            onChange={(newValue) => setSelectedDate(newValue)}
            renderInput={(params) => <TextField {...params} />}
          />

          <TimePicker
            label='From'
            value={fromTime}
            onChange={(newValue) => setFromTime(newValue)}
            renderInput={(params) => <TextField {...params} />}
          />

          <TimePicker
            label='to'
            value={toTime}
            onChange={(newValue) => setToTime(newValue)}
            renderInput={(params) => <TextField {...params} />}
          />

          <Button
            variant='contained'
            onClick={fetchRoute}
            sx={{ backgroundColor: '#BD210B' }}
          >
            Fetch Route
          </Button>
        </Box>
      </Box>
      <VehicleRouteMap apiKey={apiKey} data={jsonData} />
    </LocalizationProvider>
  );
}

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   GoogleMap,
//   Marker,
//   Polyline,
//   useJsApiLoader,
// } from "@react-google-maps/api";
// import {
//   Box,
//   Button,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   Typography,
// } from "@mui/material";
// import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import PlayArrowIcon from "@mui/icons-material/PlayArrow";
// import PauseIcon from "@mui/icons-material/Pause";

// // CONFIG
// const EMAIL = "9512292402";
// const PASSWORD = "Iks@5456";
// const BASE_URL = "https://web.onelap.in";
// const LOGIN_URL = `${BASE_URL}/api/session`;
// const DEVICES_URL = `${BASE_URL}/api/devices`;
// const AUTH_HEADER = "Basic " + btoa(`${EMAIL}:${PASSWORD}`); // replace credentials

// const mapContainerStyle = {
//   width: "100%",
//   height: "80vh",
// };

// const OneLapHistoryMap = () => {
//   const { isLoaded } = useJsApiLoader({
//     googleMapsApiKey: "YOUR_GOOGLE_MAPS_API_KEY",
//   });

//   const [devices, setDevices] = useState([]);
//   const [deviceId, setDeviceId] = useState("");
//   const [from, setFrom] = useState(dayjs().subtract(1, "hour"));
//   const [to, setTo] = useState(dayjs());
//   const [positions, setPositions] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [playing, setPlaying] = useState(false);

//   const playInterval = useRef(null);

//   // Stable fetchSession
//   const fetchSession = useCallback(async () => {
//     try {
//       const response = await fetch(LOGIN_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         credentials: "include",
//         body: new URLSearchParams({ email: EMAIL, password: PASSWORD }),
//       });
//       return response.ok;
//     } catch (err) {
//       console.error("❌ Session error:", err);
//       return false;
//     }
//   }, []);

//   // Stable fetchDevices
//   const fetchDevices = useCallback(async () => {
//     try {
//       const res = await fetch(DEVICES_URL, { credentials: "include" });
//       if (!res.ok) return [];
//       const data = await res.json();
//       setDevices(data);
//       return data;
//     } catch (err) {
//       console.error("❌ Fetch devices error:", err);
//       return [];
//     }
//   }, []);

//   // Fetch position history
//   const fetchHistory = async () => {
//     if (!deviceId || !from || !to) return;
//     try {
//       const url = new URL(`${BASE_URL}/api/reports/mini-route`);
//       url.searchParams.append("deviceId", deviceId);
//       url.searchParams.append("from", from.toISOString());
//       url.searchParams.append("to", to.toISOString());

//       const res = await fetch(url, {
//         headers: { Authorization: AUTH_HEADER },
//       });

//       const data = await res.json();
//       const formatted = data.map((p) => ({
//         lat: p.latitude,
//         lng: p.longitude,
//         fixTime: new Date(p.fixTime),
//       }));
//       setPositions(formatted);
//       setCurrentIndex(0);
//     } catch (err) {
//       console.error("Error fetching positions:", err);
//     }
//   };

//   // Timeline play/pause
//   useEffect(() => {
//     if (playing && positions.length > 0) {
//       playInterval.current = setInterval(() => {
//         setCurrentIndex((prev) => {
//           if (prev < positions.length - 1) return prev + 1;
//           clearInterval(playInterval.current);
//           setPlaying(false);
//           return prev;
//         });
//       }, 1000);
//     } else {
//       clearInterval(playInterval.current);
//     }
//     return () => clearInterval(playInterval.current);
//   }, [playing, positions]);

//   useEffect(() => {
//     fetchSession();
//     fetchDevices();
//   }, [fetchSession, fetchDevices]);

//   if (!isLoaded) return <p>Loading map...</p>;

//   return (
//     <Box p={2}>
//       <Typography variant="h5" mb={2}>
//         OneLap Vehicle History
//       </Typography>

//       {/* Controls */}
//       <Box display="flex" gap={2} mb={2}>
//         <FormControl sx={{ minWidth: 150 }}>
//           <InputLabel>Vehicle</InputLabel>
//           <Select
//             value={deviceId}
//             onChange={(e) => setDeviceId(e.target.value)}
//             label="Vehicle"
//           >
//             {devices.map((d) => (
//               <MenuItem key={d.id} value={d.id}>
//                 {d.name || d.id}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>

//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <DateTimePicker
//             label="From"
//             value={from}
//             onChange={(newVal) => setFrom(newVal)}
//           />
//           <DateTimePicker
//             label="To"
//             value={to}
//             onChange={(newVal) => setTo(newVal)}
//           />
//         </LocalizationProvider>

//         <Button variant="contained" onClick={fetchHistory}>
//           Fetch Route
//         </Button>
//       </Box>

//       {/* Map */}
//       <GoogleMap
//         mapContainerStyle={mapContainerStyle}
//         center={
//           positions.length > 0
//             ? { lat: positions[0].lat, lng: positions[0].lng }
//             : { lat: 28.6139, lng: 77.209 } // Default Delhi
//         }
//         zoom={12}
//       >
//         {positions.length > 0 && (
//           <>
//             <Polyline
//               path={positions}
//               options={{ strokeColor: "#1976d2", strokeWeight: 4 }}
//             />
//             <Marker
//               position={positions[currentIndex]}
//               icon={{
//                 url: "/car-icon.png", // custom vehicle icon
//                 scaledSize: new window.google.maps.Size(40, 40),
//               }}
//             />
//           </>
//         )}
//       </GoogleMap>

//       {/* Play/Pause */}
//       {positions.length > 0 && (
//         <Box mt={2} display="flex" gap={2}>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={() => setPlaying(true)}
//             startIcon={<PlayArrowIcon />}
//           >
//             Play
//           </Button>
//           <Button
//             variant="contained"
//             color="secondary"
//             onClick={() => setPlaying(false)}
//             startIcon={<PauseIcon />}
//           >
//             Pause
//           </Button>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default OneLapHistoryMap;
